export const STATUSES = {
    NEW:                    'NEW',
    PENDING_APPROVAL:       'PENDING_APPROVAL',
    APPROVED:               'APPROVED',
    PARTNER_DISCUSSION_DONE:'PARTNER_DISCUSSION_DONE',
    PENDING_CONFIRMATION:   'PENDING_CONFIRMATION',
    CONFIRMED:              'CONFIRMED',
    REJECTED:               'REJECTED',
};

export const IAM_EDITABLE_STATUSES = [
    STATUSES.NEW,
    STATUSES.REJECTED,
    STATUSES.APPROVED,
    STATUSES.PARTNER_DISCUSSION_DONE,
];

export const SEND_APPROVAL_STATUSES = [
    STATUSES.NEW,
    STATUSES.REJECTED,
];

export const SEND_CONFIRMATION_STATUSES = [
    STATUSES.APPROVED,
    STATUSES.PARTNER_DISCUSSION_DONE,
];

export const REJECTABLE_STATUSES = [
    STATUSES.PENDING_APPROVAL,
    STATUSES.PENDING_CONFIRMATION,
];

const isTrue = (value) => value === true || String(value) === 'true';

export const toUiStatus = (details) => {
    if (!details) return STATUSES.NEW;
    let status = details.status || STATUSES.NEW;
    if (status === 'SUBMITTED') status = STATUSES.PENDING_APPROVAL;
    else if (status === 'SENT_FOR_CONF') status = STATUSES.PENDING_CONFIRMATION;
    if (status === STATUSES.APPROVED && isTrue(details.partDiscDone)) {
        status = STATUSES.PARTNER_DISCUSSION_DONE;
    }
    return status;
};

export const toApiStatus = (uiStatus) => {
    const status = uiStatus || STATUSES.NEW;
    if (status === STATUSES.PENDING_APPROVAL) return { status: 'SUBMITTED', partDiscDone: null };
    if (status === STATUSES.PENDING_CONFIRMATION) return { status: 'SENT_FOR_CONF', partDiscDone: null };
    if (status === STATUSES.PARTNER_DISCUSSION_DONE) return { status: STATUSES.APPROVED, partDiscDone: true };
    return { status, partDiscDone: null };
};
